import { render } from "./AdministrationPage.vue?vue&type=template&id=a77f65ea&scoped=true"
import script from "./AdministrationPage.vue?vue&type=script&lang=js"
export * from "./AdministrationPage.vue?vue&type=script&lang=js"

import "./AdministrationPage.vue?vue&type=style&index=0&id=a77f65ea&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a77f65ea"]])

export default __exports__